import React from 'react';
import { motion } from 'framer-motion';
import { Quote, Star } from 'lucide-react';
export function TestimonialSection() {
  return <section className="py-12 md:py-20 px-4 bg-forest-900 border-y border-forest-700" data-id="element-273">
      <div className="max-w-5xl mx-auto" data-id="element-274">
        <div className="text-center mb-8 md:mb-16" data-id="element-275">
          <h2 className="text-3xl md:text-5xl font-serif font-bold text-gold-500 mb-4" data-id="element-276">
            Resultados Reales
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-6 md:gap-8" data-id="element-277">
          {/* Doña Rosa */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-forest-800 p-5 md:p-8 rounded-2xl border border-forest-600 relative" data-id="element-278">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-8 h-8 md:w-10 md:h-10 text-forest-600 fill-current" data-id="element-279" />
            <div className="flex gap-1 mb-4" data-id="element-280">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-281" />)}
            </div>
            <p className="text-lg md:text-xl font-serif text-cream-200 italic mb-4 md:mb-6" data-id="element-282">
              "Llevo 40 años recomendando y usando estas mismas plantas del
              Mercado Sonora. La naturaleza no se equivoca si sabes cómo
              usarla."
            </p>
            <div className="flex items-center gap-4" data-id="element-283">
              <div className="w-12 h-12 bg-forest-600 rounded-full flex items-center justify-center text-gold-500 font-bold font-serif text-xl" data-id="element-284">
                R
              </div>
              <div data-id="element-285">
                <p className="font-bold text-cream-100" data-id="element-286">Doña Rosa</p>
                <p className="text-sm text-cream-300" data-id="element-287">
                  Yerbera experta, Mercado Sonora
                </p>
              </div>
            </div>
          </motion.div>

          {/* Juan CDMX */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-forest-800 p-5 md:p-8 rounded-2xl border border-gold-500/30 relative shadow-lg shadow-gold-500/5" data-id="element-288">
            <Quote className="absolute top-4 right-4 md:top-6 md:right-6 w-8 h-8 md:w-10 md:h-10 text-gold-500/20 fill-current" data-id="element-289" />
            <div className="flex gap-1 mb-4" data-id="element-290">
              {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-4 h-4 text-gold-500 fill-gold-500" data-id="element-291" />)}
            </div>

            <div className="bg-forest-900/50 p-3 md:p-4 rounded-lg mb-4 md:mb-6 border border-forest-600" data-id="element-292">
              <div className="flex justify-between items-center mb-2" data-id="element-293">
                <span className="text-xs uppercase tracking-wider text-cream-300" data-id="element-294">
                  Antes
                </span>
                <span className="text-xs uppercase tracking-wider text-gold-400 font-bold" data-id="element-295">
                  Después (Semana 1)
                </span>
              </div>
              <div className="w-full bg-forest-700 h-2 rounded-full mb-1 overflow-hidden" data-id="element-296">
                <div className="bg-red-500/50 h-full w-[50%]" data-id="element-297" />
              </div>
              <div className="flex justify-between text-sm font-mono text-cream-200" data-id="element-298">
                <span data-id="element-299">4 horas</span>
                <span className="text-gold-400 font-bold" data-id="element-300">7.5 horas</span>
              </div>
            </div>

            <p className="text-lg md:text-xl font-serif text-cream-200 italic mb-4 md:mb-6" data-id="element-301">
              "Sin resaca, llego a la oficina nítido. Mis horas de sueño
              subieron y mis despertares bajaron a cero."
            </p>
            <div className="flex items-center gap-4" data-id="element-302">
              <div className="w-12 h-12 bg-forest-600 rounded-full flex items-center justify-center text-gold-500 font-bold font-serif text-xl" data-id="element-303">
                J
              </div>
              <div data-id="element-304">
                <p className="font-bold text-cream-100" data-id="element-305">Juan, 42 años</p>
                <p className="text-sm text-cream-300" data-id="element-306">
                  Auditor con estrés extremo, CDMX
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}